export default "__VITE_ASSET__BdztMcZz__"